module.exports = __webpack_public_path__ + "img/calendar.f85fd0df.svg";